import { getAvailableAssistiveDevicesI18nKeys } from '@/config';
import type {
  AssistiveDeviceBase,
  CompanionsFormValues,
  Companionship,
  FormItemConfigRaw,
} from '@/types';

/** Sélection des équipements pour les accompagnateurs */
export type CompanionDevicesSelection = {
  /** Équipements pour les accompagnateurs ayant été sélectionnés */
  devices: string[];
  /** Autre équipement pour les accompagnateurs, si l'option "Autre" a été sélectionné dans la liste des équipements */
  other: string;
};

/** Données stockées dans Pinia en lien avec les équipements pour les accompagnateurs */
export type CompanionDevicesStored = CompanionDevicesSelection & {
  /** Équipements pour les accompagnateurs, adaptés du modèle backend lors d'une modification d'un déplacement */
  modificationDevices: CompanionAssistiveDevice[];
};

/** Équipements pour les accompagnateurs et adaptés du modèle backend lors d'une modification d'un déplacement */
export type CompanionAssistiveDevice = AssistiveDeviceBase;

/** Éléments du formulaire des accompagnateurs, sous la forme originale "non-traduite" */
export type CompanionFormItemRaw = FormItemConfigRaw<Companionship>;

/** Nom de l'élément de formulaire pour les accompagnateurs lors du trajet 'aller' */
const COMPANIONS_FORM_ITEM_NAME_OUTWARD = 'companions.outward';

/** Nom de l'élément de formulaire pour les accompagnateurs lors du trajet 'retour' seulement */
const COMPANIONS_FORM_ITEM_NAME_INWARD = 'companions.inward';

/** Valeur assignée au checkbox "Autre" dans la liste des aides à la mobilité sélectionnables */
const COMPANIONS_DEVICES_OTHER_CHECKBOX_VALUE = 'other';

/** Nom unique de l'élément de formulaire pour la liste des aides sélectionnées pour les accompagnateurs */
const COMPANIONS_DEVICES_ITEM_NAME = 'companions.assistiveDevices';

/** Nom unique de l'élément de formulaire pour le champ texte "autre équipement" pour les accompagnateurs */
const COMPANIONS_OTHER_DEVICES_ITEM_NAME = 'companions.otherDevice';

/** Nom de l'élément de formulaire pour les équipements des accompagnateurs lors d'une modification de déplacement */
const COMPANIONS_MODIFICATION_DEVICES_ITEM_NAME = 'companions.modificationDevices';

/**
 * Retourne l'objet d'accompagnateurs avec des valeurs nulles pour chaque type (défaut).
 */
function getEmptyCompanions(): CompanionsFormValues {
  return {
    parents: null,
    children: null,
    travelling: null,
  };
}

export {
  COMPANIONS_DEVICES_OTHER_CHECKBOX_VALUE,
  COMPANIONS_DEVICES_ITEM_NAME,
  COMPANIONS_OTHER_DEVICES_ITEM_NAME,
  COMPANIONS_MODIFICATION_DEVICES_ITEM_NAME,
  COMPANIONS_FORM_ITEM_NAME_INWARD,
  COMPANIONS_FORM_ITEM_NAME_OUTWARD,
  getAvailableAssistiveDevicesI18nKeys,
  getEmptyCompanions,
};
